import {FlexBox, useBreakpoint, useIsMobile, useScale} from "@brg/ui";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HolderContent, ImagePreviewSectionImage, ImagePreviewSectionWrapper } from "shared/components/ImagePreviewSection/ImagePreviewSection";
import styled, { useTheme } from "styled-components";
import { BookChaptersEmptyContainer, BookEmptyAddChapterButton, BookSelectChaptersButton } from "./styles";
import Michelangelo from "../../../../../shared/components/inputs/assets/cover_placeholders/Michelangelo.svg"
import { Book, Endpoints, Project } from "@brg/api";
import { getProjectImages } from "shared/pages/project/sections/ps-image";
import { useResizedImageEnhanced } from "shared/hooks/useResizedImageEnhanced";
import {LayoutConst} from "../../../../../core";

const InputHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
export interface BookChaptersEmptyProps {
    canCreateChapter: boolean;
    onSelectChaptersClick: () => void;
    onCreateChapterClick: () => void;
    book: Book;
    previewProject?: Project;
};  

const getImages = (project: Book<'Local'> | Project<'Local'>, lang: string) => {
    return getProjectImages(project, lang)
  }

export const BookImageContainer: FC<BookChaptersEmptyProps> = ({
    canCreateChapter,
    onSelectChaptersClick,
    onCreateChapterClick,
    book,
    previewProject
}) => {
    const { t, i18n } = useTranslation();
    const s = useScale();
    const is744 = useBreakpoint(LayoutConst.screen.s);

    const titleImages = getImages(previewProject || book, i18n.language);

    const [image, ref] = useResizedImageEnhanced(titleImages);

    const imageUrl = useMemo(() => {
        return (image?.url ? `${Endpoints.files}/${image.url}` : '');
      },[ref?.current, image])
    
    return  (
        <BookChaptersEmptyContainer
            width={s(564)}
            height={s(792)}
            heightMobile={is744 ? 'calc((100vw - 20px) * 1.407)' : 'calc((50vw - 55px - 8px) * 1.407)'}
            widthMobile={is744 ? 'calc(100vw - 20px)' : 'calc(50vw - 55px - 8px)'}
            ref={ref} 
            imgShowed={Boolean(imageUrl)}
        >
            {imageUrl ? (
                <InputHolder>
                    <ImagePreviewSectionWrapper
                        width={s(564)}
                        height={s(792)}
                        heightMobile={is744 ? 'calc((100vw - 20px) * 1.407)' : 'calc((50vw - 55px - 8px) * 1.407)'}
                        widthMobile={is744 ? 'calc(100vw - 20px)' : 'calc(50vw - 55px - 8px)'}
                        withoutMac13Size={false}
                        isProjectEdit={false}
                        isBookEdit
                    >
                        <ImagePreviewSectionImage         
                            width={100}
                            height={100}
                            url={imageUrl}
                        />
                    </ImagePreviewSectionWrapper>
                </InputHolder> 
            ) : (
                <HolderContent holderHeight={50} url={Michelangelo} placeholderMargin={32} placeholderMaxWidth={300}>
                    <FlexBox direction={"column"} directionMobile={'column'} gy={24} gyMobile={24} align={'center'}>
                        <FlexBox justify="center" width={320}>
                            {t('book_edit.chapters.info')}
                        </FlexBox>
                        <BookEmptyAddChapterButton title={!canCreateChapter ? t('book_edit.frames.title_saved') : ''} disabled={!canCreateChapter} onClick={onCreateChapterClick}>
                            {t('book_edit.chapters.button_start')}
                        </BookEmptyAddChapterButton>
                        <BookSelectChaptersButton onClick={onSelectChaptersClick}>
                            {t('book_edit.chapters.button_exists')}
                        </BookSelectChaptersButton>
                    </FlexBox>
                </HolderContent>  
            )}
        </BookChaptersEmptyContainer>
    );
};import {FlexBox, useBreakpoint, useIsMobile, useScale} from "@brg/ui";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HolderContent, ImagePreviewSectionImage, ImagePreviewSectionWrapper } from "shared/components/ImagePreviewSection/ImagePreviewSection";
import styled, { useTheme } from "styled-components";
import { BookChaptersEmptyContainer, BookEmptyAddChapterButton, BookSelectChaptersButton } from "./styles";
import Michelangelo from "../../../../../shared/components/inputs/assets/cover_placeholders/Michelangelo.svg"
import { Book, Endpoints, Project } from "@brg/api";
import { getProjectImages } from "shared/pages/project/sections/ps-image";
import { useResizedImageEnhanced } from "shared/hooks/useResizedImageEnhanced";
import {LayoutConst} from "../../../../../core";

const InputHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
export interface BookChaptersEmptyProps {
    canCreateChapter: boolean;
    onSelectChaptersClick: () => void;
    onCreateChapterClick: () => void;
    book: Book;
    previewProject?: Project;
};  

const getImages = (project: Book<'Local'> | Project<'Local'>, lang: string) => {
    return getProjectImages(project, lang)
  }

export const BookImageContainer: FC<BookChaptersEmptyProps> = ({
    canCreateChapter,
    onSelectChaptersClick,
    onCreateChapterClick,
    book,
    previewProject
}) => {
    const { t, i18n } = useTranslation();
    const s = useScale();
    const is744 = useBreakpoint(LayoutConst.screen.s);

    const titleImages = getImages(previewProject || book, i18n.language);

    const [image, ref] = useResizedImageEnhanced(titleImages);

    const imageUrl = useMemo(() => {
        return (image?.url ? `${Endpoints.files}/${image.url}` : '');
      },[ref?.current, image])
    
    return  (
        <BookChaptersEmptyContainer
            width={s(564)}
            height={s(792)}
            heightMobile={is744 ? 'calc((100vw - 20px) * 1.407)' : 'calc((50vw - 55px - 8px) * 1.407)'}
            widthMobile={is744 ? 'calc(100vw - 20px)' : 'calc(50vw - 55px - 8px)'}
            ref={ref} 
            imgShowed={Boolean(imageUrl)}
        >
            {imageUrl ? (
                <InputHolder>
                    <ImagePreviewSectionWrapper
                        width={s(564)}
                        height={s(792)}
                        heightMobile={is744 ? 'calc((100vw - 20px) * 1.407)' : 'calc((50vw - 55px - 8px) * 1.407)'}
                        widthMobile={is744 ? 'calc(100vw - 20px)' : 'calc(50vw - 55px - 8px)'}
                        withoutMac13Size={false}
                        isProjectEdit={false}
                        isBookEdit
                    >
                        <ImagePreviewSectionImage         
                            width={100}
                            height={100}
                            url={imageUrl}
                        />
                    </ImagePreviewSectionWrapper>
                </InputHolder> 
            ) : (
                <HolderContent holderHeight={50} url={Michelangelo} placeholderMargin={32} placeholderMaxWidth={300}>
                    <FlexBox direction={"column"} directionMobile={'column'} gy={24} gyMobile={24} align={'center'}>
                        <FlexBox justify="center" width={320}>
                            {t('book_edit.chapters.info')}
                        </FlexBox>
                        <BookEmptyAddChapterButton title={!canCreateChapter ? t('book_edit.frames.title_saved') : ''} disabled={!canCreateChapter} onClick={onCreateChapterClick}>
                            {t('book_edit.chapters.button_start')}
                        </BookEmptyAddChapterButton>
                        <BookSelectChaptersButton onClick={onSelectChaptersClick}>
                            {t('book_edit.chapters.button_exists')}
                        </BookSelectChaptersButton>
                    </FlexBox>
                </HolderContent>  
            )}
        </BookChaptersEmptyContainer>
    );
};